(function () {
  'use strict';
  var key = 'bioss-catalog-page-size-v1';
  var sizes = [12, 24, 48];
  var desktop = window.matchMedia('(min-width: 1280px)');
  var preferred = 12;
  var requested = 12;
  var ready = false;
  var loading = false;
  var pendingRequests = 0;
  var catalog;
  function valid(value) { return sizes.indexOf(Number(value)) !== -1; }
  try { if (valid(localStorage.getItem(key))) preferred = Number(localStorage.getItem(key)); } catch (_) {}
  function notify() { window.dispatchEvent(new CustomEvent('bioss:catalog-page-size')); }
  function navigate(size) {
    if (!ready || !catalog || typeof catalog.Location !== 'function') return false;
    var location = new catalog.Location();
    location.remove(catalog.context.pagination || 'page');
    location.remove('perpage');
    location.add('perpage', size);
    loading = true;
    location.go();
    window.dispatchEvent(new PopStateEvent('popstate', { state: window.history.state }));
    return true;
  }
  window.BiossCatalogPageSize = {
    install: function () {
      if (catalog) return;
      catalog = window.SearchSpring && window.SearchSpring.Catalog;
      if (!catalog) return;
      catalog.on('beforeSearch', function (parameters, options) {
        options = options || {};
        if (options.moduleName || (options.endpoint && options.endpoint !== 'search' && options.endpoint !== 'category')) return;
        if (desktop.matches && valid(parameters.resultsPerPage)) preferred = Number(parameters.resultsPerPage);
        requested = desktop.matches ? preferred : 12;
        parameters.resultsPerPage = requested;
        ready = true;
        pendingRequests += 1;
        loading = true;
        notify();
      });
      catalog.on('afterSearch', function (scope) {
        if (scope && scope.moduleName) return;
        pendingRequests = Math.max(0, pendingRequests - 1);
        loading = pendingRequests > 0;
        notify();
      });
      catalog.on('_searchError', function () {
        pendingRequests = 0;
        loading = false;
        notify();
      });
    },
    get: function () { return desktop.matches ? preferred : 12; },
    ready: function () { return ready; },
    busy: function () { return loading; },
    set: function (value) {
      if (!desktop.matches || loading || !valid(value)) return false;
      if (ready && Number(value) === preferred) return true;
      var previous = preferred;
      preferred = Number(value);
      if (!navigate(preferred)) { preferred = previous; return false; }
      try { localStorage.setItem(key, String(preferred)); } catch (_) {}
      notify();
      return true;
    }
  };
  function resize() {
    var next = desktop.matches ? preferred : 12;
    if (ready && requested !== next) navigate(next);
    notify();
  }
  if (desktop.addEventListener) desktop.addEventListener('change', resize);
  else desktop.addListener(resize);
})();
